import router from './router'
import store from './stores'
import { getToken, removeToken } from './utils/auth'
import { Message } from 'element-ui'

// const whiteList = ['/login'] // 不重定向白名单

// 添加路由守卫
router.beforeEach((to, from, next) => {
  const token = getToken()
  if (!token) {
    next()
  } else if (!(store.getters.userInfo && store.getters.userInfo.user_id)) {
    store.dispatch('getUserInfo').then(res => {
      if (res.result.user_id) {
      } else {
        Message.error('用户登录信息已失效，请重新登录')
      }
      next()
    }).catch(_ => {
      // Message.error('未获取到用户信息，请重新登录')
      removeToken()
      next('/home')
    })
  } else {
    next()
  }
  // let userInfo = JSON.parse(localStorage.getItem('userInfo'))
  // store.commit('SET_USER_INFO', userInfo)
  // next()
})
